<template>
    <div class="myDept-box">
        <div
            v-if="defaultState === 'more' || defaultState === 'one'"
            class="deptMain"
        >
            <template v-for="(breadItem, index) in breadcrumbList">
                <div :key="index + 'bread'" class="deptBread">
                    <img
                        v-if="defaultState === 'more'"
                        src="@/assets/images/contacts/arrow_contact.png"
                        alt=""
                        class="arrow"
                        :class="{ rotate: breadItem.expand }"
                        @click="expand(breadItem)"
                    >
                    <p class="breadDetail">
                        <template
                            v-for="(orgItem, index2) in breadItem.breadcrumb"
                        >
                            <template
                                v-if="
                                    index2 !==
                                        breadItem.breadcrumb.length - 1 &&
                                        orgItem.hasClickAuth
                                "
                            >
                                <a
                                    :key="orgItem.bizId"
                                    @click="changeOrg(orgItem, breadItem)"
                                >{{ orgItem.name }}</a><i :key="index2">/</i>
                            </template>
                            <template
                                v-else-if="
                                    index2 !==
                                        breadItem.breadcrumb.length - 1 &&
                                        !orgItem.hasClickAuth
                                "
                            >
                                <span :key="orgItem.bizId">{{
                                    orgItem.name
                                }}</span><i :key="index2">/</i>
                            </template>
                            <template v-else>
                                <span :key="orgItem.bizId">{{
                                    orgItem.name
                                }}</span>
                            </template>
                        </template>
                    </p>
                </div>
                <div
                    v-if="breadItem.data"
                    v-show="breadItem.expand"
                    :key="index"
                    class="deptDetail"
                    :class="{ hasArrow: defaultState === 'more' }"
                >
                    <label
                        v-show="
                            breadItem.data.members.length > 0 ||
                                breadItem.data.depts.length > 0
                        "
                        class="allCheck"
                        :for="
                            breadItem['breadcrumb'][
                                breadItem['breadcrumb'].length - 1
                            ]['bizId']
                        "
                    >
                        <label
                            class="checkIcon"
                        ><input
                            :id="
                                breadItem['breadcrumb'][
                                    breadItem['breadcrumb'].length - 1
                                ]['bizId']
                            "
                            v-model="selectedOrgs"
                            type="checkbox"
                            :value="
                                breadItem['breadcrumb'][
                                    breadItem['breadcrumb'].length - 1
                                ]['bizId']
                            "
                            @change="
                                changeOrgCheck(
                                    $event,
                                    breadItem['breadcrumb'][
                                        breadItem['breadcrumb'].length - 1
                                    ]
                                )
                            "
                        ><i /></label><span>全选</span>
                    </label>
                    <ul
                        v-if="breadItem.data && breadItem.data.members"
                        class="memberList"
                    >
                        <label
                            v-for="memberItem in breadItem.data.members"
                            :key="memberItem.lxAccount"
                            class="member"
                            :for="memberItem.id"
                            @change="changeMemberCheck($event, memberItem)"
                        >
                            <label
                                class="checkIcon"
                            ><input
                                :id="memberItem.id"
                                v-model="selectedIdList"
                                type="checkbox"
                                :value="memberItem.id"
                                :disabled="isDisabled(memberItem)"
                            ><i /></label>
                            <Avatar class="avatar" :user="memberItem" />
                            <div class="detail">
                                <p class="name">
                                    <span class="name-flex">{{
                                        memberItem.name
                                    }}</span>
                                    <span
                                        class="account"
                                    >({{ memberItem.lxAccount }})</span>
                                </p>
                                <p class="position">
                                    {{ memberItem.tag1 }}
                                </p>
                            </div>
                        </label>
                    </ul>
                    <ul
                        v-if="breadItem.data && breadItem.data.depts"
                        class="deptList"
                    >
                        <li
                            v-for="deptItem in breadItem.data.depts"
                            :key="deptItem.bizId"
                            class="dept"
                            @click="changeOrg(deptItem, breadItem, $event)"
                        >
                            <label
                                class="checkIcon"
                                @click.stop=""
                            ><input
                                v-model="selectedOrgs"
                                :value="deptItem.bizId"
                                type="checkbox"
                                @change="
                                    changeOrgCheck($event, deptItem)
                                "
                            ><i /></label>
                            <p class="detail">
                                {{ deptItem.name }}
                            </p>
                            <img
                                src="@/assets/images/contacts/arrow-right.png"
                                alt=""
                                class="expandIcon"
                            >
                        </li>
                    </ul>
                    <div
                        v-show="
                            breadItem.data.members.length === 0 &&
                                breadItem.data.depts.length === 0
                        "
                        class="org-default-bg"
                    >
                        <span>暂无数据</span>
                    </div>
                </div>
            </template>
        </div>
        <div v-if="defaultState === 'loading'" class="org-status">
            <img
                src="https://s1.longfor.com/image/40348b3e1ff6aa6833902accafcc0c4f.gif"
                alt=""
                class="status-img"
            >
            <p class="status-text">
                加载中
            </p>
        </div>
        <div v-if="defaultState === 'none'" class="org-status">
            <img
                src="../../../assets/images/contacts/org-window-empty-bg.png"
                class="status-img"
                alt=""
            >
            <p class="status-text">
                暂无所属部门
            </p>
        </div>
        <div v-if="defaultState === 'dataLoadingFailed'" class="org-status">
            <img
                src="@/assets/images/contacts/data_loading_failed.png"
                alt=""
                class="status-img"
            >
            <p class="status-text">
                数据加载失败，请重试
            </p>
            <div class="status-reload">
                <button type="button" class="reload" @click="reload()">
                    重新加载
                </button>
            </div>
        </div>
        <div v-if="defaultState === 'serviceAbnormal'" class="org-status">
            <img
                src="@/assets/images/contacts/service_abnormal.png"
                alt=""
                class="status-img"
            >
            <p class="status-text">
                服务异常，请联系IT报事
            </p>
            <div class="status-reload">
                <button type="button" class="reload" @click="reload()">
                    重新加载
                </button>
            </div>
        </div>
        <div v-if="defaultState === 'networkAbnormal'" class="org-status">
            <img
                src="@/assets/images/contacts/network_abnormal.png"
                alt=""
                class="status-img"
            >
            <p class="status-text">
                当前网络不可用，请检查网络设置
            </p>
            <div class="status-reload">
                <button type="button" class="reload" @click="reload()">
                    重新加载
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {
    getUserOrgInfo,
    getPathListByBizId,
    getOrgMembersCount,
    getAllMembers,
    contactsBatch,
    getNextOrganization
} from '@/apis/contactsWindow/contactsWindow'
import Avatar from '@/components/Avatar'
import contactsConfig from '@/utils/contacts/config'

export default {
    name: 'MyDept',
    components: {
        Avatar
    },
    props: {
        selected: {
            type: [Array],
            required: false,
            default: () => []
        },
        countLimit: {
            type: [Number],
            required: true
        },
        isStaff: {
            type: Boolean,
            required: true,
            default: false
        },
        loginRights: {
            type: Object,
            required: true
        },
        defaultSelected: {
            type: [Array],
            required: false,
            default: () => []
        },
        canNotSelected: {
            type: [Array],
            required: false,
            default: () => []
        }
    },
    data() {
        return {
            deptList: [], // 我的部门基本信息，其中的pid为breadcrumbList的orgId
            defaultState: '', // loading：未获取到，none：deptList为空，more：deptList>1，one：deptList===1
            breadcrumbList: [], // 我的所有部门相关信息的list。包含（orgId、breadcrumb、expand、data）
            selectedOrgs: [], // 选择的组架节点
            orgBusy: {}, // 选择组织节点时查库的 busy
            orgAllMembersCache: {}, // 组织节点全选查库之后的缓存
            crumbCacheList: {},
            contactRootNode: {
                longforCorporationPid: '1000000004',
                longforPid: '1000000003',
                regionPid: '6000000001'
            }
        }
    },
    computed: {
        selectedIdList: {
            get() {
                return this.selected.map(item => item.id)
            },
            set() {}
        },
        defaultIdList() {
            return (this.defaultSelected || []).map(item => item.id)
        },
        canNotSelectedIds() {
            return this.canNotSelected || []
        },
        // 是否有通讯录权限:-1无权限;0低权限;1高权限
        userLevel() {
            return !this.loginRights.authorityGrade
                ? -1
                : +this.loginRights.authorityGrade
        }
    },
    mounted() {
        setTimeout(() => {
            if (!this.defaultState) {
                this.defaultState = 'loading'
            }
        }, contactsConfig.loadingTimeout)
        this.getUserOrgInfo()
    },
    methods: {
        reload() {
            this.defaultState = 'loading'
            this.getUserOrgInfo()
        },
        // 获取用户所有部门
        getUserOrgInfo() {
            const context = this
            getUserOrgInfo()
                .then(orgInfo => {
                    if (orgInfo.code === '0') {
                        context.deptList = orgInfo.data.deptInfo
                        // context.deptList = [];
                        if (context.deptList.length === 0) {
                            this.defaultState = 'none' // 无部门显示缺省图
                            if (context.isStaff && context.userLevel >= 1) {
                                context.deptList = [
                                    {
                                        fullPath: '龙湖集团', // 没用到，暂留着
                                        pid: context.contactRootNode.longforPid // 没对接组织直接显示组架
                                    }
                                ]
                                this.defaultState = 'one' // 无部门显示组织架构，只显示组架走one的逻辑，无箭头
                            }
                        } else if (context.deptList.length > 1) {
                            this.defaultState = 'more' // 多部门面包屑左边有箭头，自动展开第一组
                        } else {
                            this.defaultState = 'one' // 单部门无箭头、且自动展开
                        }
                        context.getPathList(context.deptList)
                    } else {
                        this.defaultState = 'dataLoadingFailed'
                    }
                })
                .catch(err => {
                    if (err.message === 'Network Error') {
                        context.defaultState = 'networkAbnormal' // 当前网络不可用，请检查网络设置
                    } else {
                        context.defaultState = 'serviceAbnormal' // 服务异常，请联系IT报事
                    }
                })
        },
        // 获取所有部门的面包屑path
        getPathList(list) {
            const context = this
            context.breadcrumbList = [] // 清空面包屑list
            if (list.length === 0) {
                return
            }
            // if (list[0].pid === context.contactRootNode.longforPid) {
            //     const obj = {
            //         orgId: list[0].pid,
            //         breadcrumb: '',
            //         expand: false,
            //         data: ''
            //     }
            //     context.breadcrumbList.push(obj)
            //     const breadcrumb = [
            //         {
            //             pId: '',
            //             name: '龙湖集团',
            //             type: 1,
            //             bizId: '1000000003',
            //             tag1: null,
            //             nId: '1000000003',
            //             idPath: '',
            //             hasClickAuth: context.userLevel === '1'
            //         }
            //     ]
            //     obj.breadcrumb = breadcrumb
            //     context.expand(obj)
            //     return
            // }
            for (let i = 0; i < list.length; i++) {
                const obj = {
                    orgId: list[i].pid,
                    breadcrumb: '',
                    expand: false,
                    data: ''
                }
                context.breadcrumbList.push(obj) // 先把obj push进来，保证不会因为异步乱序
                getPathListByBizId(list[i].pid)
                    .then(res => {
                        if (res.code === '0') {
                            if (res.data.length > 0) {
                                const breadcrumb = []
                                const pathList = res.data.filter(item => item)
                                pathList.forEach(item => {
                                    breadcrumb.push({
                                        pId: item.pId,
                                        name: item.name,
                                        type: item.type,
                                        bizId: item.bizId,
                                        tag1: item.tag1,
                                        nId: item.nId,
                                        idPath: item.idPath,
                                        hasClickAuth:
                                            context.isStaff &&
                                            context.userLevel >= 1
                                    })
                                })
                                obj.breadcrumb = breadcrumb // 拿到面包屑后赋值给obj
                                if (i === 0) {
                                    // 第一个默认展开，需要获取其内部数据
                                    context.expand(obj)
                                }
                            } else {
                                console.warn('获取到的path长度为0')
                            }
                        } else {
                            this.defaultState = 'dataLoadingFailed'
                        }
                    })
                    .catch(err => {
                        if (err.message === 'Network Error') {
                            context.defaultState = 'networkAbnormal' // 当前网络不可用，请检查网络设置
                        } else {
                            context.defaultState = 'serviceAbnormal' // 服务异常，请联系IT报事
                        }
                    })
            }
        },
        // '首次'点击小三角触发，获取组织下的人员&组织信息
        expand(breadItem) {
            const context = this
            breadItem.expand = !breadItem.expand
            // 如果data里有数据，说明之前展开过，获取过数据，只需进行简单的展开/收起操作即可
            if (breadItem.expand && !breadItem.data) {
                getNextOrganization(breadItem.orgId, (err, res) => {
                    if (err) {
                        context.defaultState = 'serviceAbnormal' // 服务异常，请联系IT报事
                        console.warn(err)
                        return
                    }
                    const depts = []
                    const members = []
                    res.forEach(item => {
                        if (item.type === contactsConfig.DEPT) {
                            depts.push(item)
                        } else if (item.type === contactsConfig.STAFF) {
                            members.push(item)
                        }
                    })
                    context.$set(breadItem, 'data', { depts, members })
                })
            }
        },
        // 切换部门
        changeOrg(orgItem, breadItem, e) {
            const context = this
            let breadDom = null
            if (e) {
                breadDom =
                    e.currentTarget.parentElement.parentElement
                        .previousElementSibling
            }
            const orgId = orgItem.bizId
            let isHasOrg = false
            let index = -1
            let length = -1
            let lastItem = {}
            // 当前组织是否在面包屑导航中存在
            isHasOrg = breadItem.breadcrumb.some(item => item.bizId === orgId)
            // 组织不存在，向后追加一级path
            if (!isHasOrg) {
                // 外部员工 - 无上级组织路径权限，有下级组织路径权限，内部员工，有所有路径权限。
                // 外部员工需要把上层变成可点击的
                if (context.isStaff && context.userLevel < 1) {
                    length = breadItem.breadcrumb.length
                    lastItem = breadItem.breadcrumb[length - 1]
                    this.$set(lastItem, 'hasClickAuth', true)
                }
                breadItem.breadcrumb.push({
                    bizId: orgId,
                    name: orgItem.name,
                    hasClickAuth: true
                })
            } else {
                // 当前节点已存在于面包屑导航中，删除点击节点及之后的节点 (ie不支持findIndex)
                let flag = false
                for (let i = 0; i < breadItem.breadcrumb.length; i++) {
                    if (breadItem.breadcrumb[i].bizId === orgId) {
                        index = i
                        flag = true
                    }
                }
                if (!flag) {
                    index = -1
                }
                // index = breadItem.breadcrumb.findIndex(item => item.bizId === orgId)
                breadItem.breadcrumb.splice(index + 1)
            }
            const func = function() {
                if (!breadItem.expand) {
                    // 点击某一个组架，自动展开下面的详情
                    breadItem.expand = true
                }
                // 如果是点击下级的话，自动滚动到顶部
                breadDom && breadDom.scrollIntoView()
            }
            // 有缓存取缓存，没有的话请求接口
            if (context.crumbCacheList[orgId]) {
                const obj = context.crumbCacheList[orgId]
                context.$set(breadItem, 'data', {
                    depts: obj.depts,
                    members: obj.members
                })
                func()
                return
            }
            getNextOrganization(orgId, (err, res) => {
                if (err) {
                    console.warn(err)
                    return
                }
                const depts = []
                const members = []
                res.forEach(item => {
                    if (item.type === contactsConfig.DEPT) {
                        depts.push(item)
                    } else if (item.type === contactsConfig.STAFF) {
                        members.push(item)
                    }
                })
                context.crumbCacheList[orgId] = {
                    id: orgItem.bizId,
                    deptName: orgItem.name,
                    members,
                    depts,
                    companies: []
                }
                context.$set(breadItem, 'data', { depts, members })
                func()
            })
        },
        changeMemberCheck(event, item) {
            const checked = event.target.checked
            const context = this
            if (checked) {
                if (context.countLimit) {
                    const count = context.selected.length + 1
                    if (count > context.countLimit) {
                        context.$nextTick(() => {
                            // 人数超了不需要选中
                            event.target.checked = false
                        })
                        context.$emit('maxCountLimit')
                        return
                    }
                }
                // 先添加到 selected 列表中
                context.$emit('added', [item])
                // 选择所有当前 staff 相关的节点
                // this.addAllContactStaff([item])
            } else {
                // 先 remove selected
                context.$emit('removed', [item])
                // this.removeMembers([item])
            }
        },
        // 提供给其他组件使用，联动 判断上级组织节点是否被选中
        addAllContactStaff(members, isAllCheck) {
            if (!isAllCheck) {
                const idList = members.map(item => item.id)
                contactsBatch(idList[0]).then(staffs => {
                    if (staffs.code === '0') {
                        staffs.data.forEach(member => {
                            checkOrgSelect(member, this)
                        })
                    } else {
                        console.warn(staffs.msg)
                    }
                })
            }
        },
        removeMembers(members, isAllCheck) {
            if (members.length === 0) {
                return
            }
            const context = this
            if (!isAllCheck) {
                // 用于删除父级组织节点，去重
                const orgIds = []
                const orgMap = {}
                contactsBatch([members[0].id]).then(staffs => {
                    if (staffs.code === '0') {
                        staffs.data.forEach(staff => {
                            const ids = staff.idPath.split(',')
                            ids.forEach(id => {
                                if (!orgMap[id]) {
                                    orgMap[id] = id
                                    orgIds.push(id)
                                }
                            })
                        })
                        context.selectedOrgs = context.selectedOrgs.filter(
                            bizId => orgIds.indexOf(bizId) < 0
                        )
                    }
                })
            }
        },
        /*
        说明：获取全选状态
        步骤：判断已选 部门 中是否包含当前节点
        */
        // getCheckedAll() {
        //     const context = this;
        //     const searchResult = context.searchResult;
        //     if (searchResult.id) {
        //         return context.selectedOrgs.indexOf(searchResult.id) > -1;
        //     }
        //     return false;
        // },
        /*
        说明：设置全选获取
        步骤：模拟上一层的组架的点击
        */
        // setCheckedAll(checked) {
        //     const context = this;
        //     const searchResult = context.searchResult;
        //     if (searchResult.id) {
        //         const orgInfo = {
        //             bizId: searchResult.id,
        //             idPath: context.breadcrumb.map(pathItem => pathItem.bizId).join(','),
        //         };
        //         if (checked) {
        //             addDepts(orgInfo, context);
        //         } else {
        //             removeDepts(orgInfo, context);
        //         }
        //     } else {
        //         context.selectedOrgs.push({});
        //         context.selectedOrgs.pop();
        //         context.$emit('maxCountLimit');
        //     }
        // },
        changeOrgCheck(event, item) {
            if (item.bizId && !item.nId) {
                item.nId = item.bizId
            }
            const context = this
            const checked = event.target.checked
            if (checked) {
                context.addDepts(item)
            } else {
                context.removeDepts(item)
            }
        },
        // 选择一个组织节点
        addDepts(item) {
            if (item.nId) {
                getPathListByBizId(item.nId).then(res => {
                    if (res.code === '0') {
                        item.idPath = res.data
                            .filter(result => result.nid === item.nId)
                            .map(result => result.idPath)[0]
                    }
                })
            }
            const context = this
            const orgBusy = context.orgBusy
            // 如果当前节点正在选择中，return 掉，防止用户频繁点击
            if (orgBusy[item.bizId]) {
                return
            }
            orgBusy[item.bizId] = item
            // 先从节点中删除掉当前已选节点，如果之后删除，页面会闪动选择
            context.$nextTick(() => {
                context.selectedOrgs = context.selectedOrgs.filter(
                    bizId => bizId !== item.bizId
                )
            })
            let depts
            let members
            const allMembersFunc = function() {
                // 选择当前节点
                context.selectedOrgs.push(item.bizId)
                delete orgBusy[item.bizId]
                // 选择所有子组架节点
                depts.forEach(dept => {
                    if (context.selectedOrgs.indexOf(dept.bizId) < 0) {
                        context.selectedOrgs.push(dept.bizId)
                    }
                })
                // 递归判断上级是否选中
                checkOrgSelect(item, context)
                // add staff 到已选列表中
                addMembers(members, context)
            }
            // 先判断组织节点总数是否超出限制
            // staffIds, 当前已选的 id，需过滤
            // const staffIds = context.selected.filter(staff => !isGroup(staff)).map(staff => staff.id);
            const staffIds = context.selected.map(staff => staff.id)
            getOrgMembersCount({ uids: [item.bizId] }, staffIds).then(res => {
                if (res.code !== '0') {
                    context.$message({
                        message: '获取组织总人数失败',
                        type: 'error',
                        duration: 3000
                    })
                    return
                }
                if (context.countLimit) {
                    const selectedCount =
                        res.data.totalCount + context.selected.length
                    if (selectedCount > context.countLimit) {
                        delete orgBusy[item.bizId]
                        context.$emit('maxCountLimit')
                        return
                    }
                }
                // 如果有组件缓存数据，使用组件缓存数据
                // if (context.orgAllMembersCache[item.bizId]) {
                //     depts = context.orgAllMembersCache[item.bizId].depts
                //     members = context.orgAllMembersCache[item.bizId].members
                //     allMembersFunc()
                //     return
                // }
                // 获取组织下的所有节点
                getAllMembers(item.bizId, (errorCode, res) => {
                    if (errorCode) {
                        context.$message({
                            message: '获取组织下所有节点失败',
                            type: 'error',
                            duration: 3000
                        })
                        return
                    }
                    depts = res.depts
                    members = res.members
                    // 缓存当前节点的数据
                    context.orgAllMembersCache[item.bizId] = {
                        members,
                        depts
                    }
                    allMembersFunc()
                })
            })
        },
        // 删除一个组织节点
        removeDepts(item) {
            let idPath = []
            if (item.nId) {
                getPathListByBizId(item.nId).then(res => {
                    if (res.code === '0') {
                        idPath = res.data
                            .filter(result => result.nid === item.nId)
                            .map(result => result.idPath)[0]
                            .split(',')
                    }
                })
            }
            const context = this
            const orgBusy = context.orgBusy
            // 如果当前节点正在选择中，return 掉，防止用户频繁点击
            if (orgBusy[item.bizId]) {
                return
            }
            orgBusy[item.bizId] = item
            // 先不让节点取消选择，之后再取消，同步已选列表
            context.selectedOrgs.push(item.bizId)
            getAllMembers(item.bizId, (errorCode, res) => {
                // 取消选择节点
                context.selectedOrgs = context.selectedOrgs.filter(
                    bizId => bizId !== item.bizId
                )
                delete orgBusy[item.bizId]
                if (errorCode) {
                    context.$message({
                        message: '获取数据失败',
                        type: 'error',
                        duration: 3000
                    })
                    return
                }
                const { depts, members } = res
                // 删除组架子节点
                const deptBizIds = depts.map(dept => dept.bizId)
                context.selectedOrgs = context.selectedOrgs.filter(
                    bizId => deptBizIds.indexOf(bizId) < 0
                )
                // 删除组架父级节点
                // if (item.idPath) {
                //     const orgIds = item.idPath.split(',')
                //     context.selectedOrgs = context.selectedOrgs.filter(
                //         bizId => orgIds.indexOf(bizId) < 0
                //     )
                // }
                if (idPath.length) {
                    context.selectedOrgs = context.selectedOrgs.filter(
                        bizId => idPath.indexOf(bizId) < 0
                    )
                }
                // 从已选列表中 remove staff
                if (members.length > 0) {
                    context.$emit('removed', members)
                }
            })
        },
        /* 成员的禁用状态，是否可选择、取消。 1.默认选中成员 */
        isDisabled(item) {
            return (
                this.isDefault(item) ||
                this.executiveLimit(item) ||
                this.isCannotSelected(item)
            )
        },
        isDefault(item) {
            return this.defaultIdList.indexOf(item.id) >= 0
        },
        executiveLimit(item) {
            if (this.isStaff && this.userLevel >= 1) {
                return false
            }
            const isExec = item && !!+item.isExec
            return isExec
        },
        isCannotSelected(item) {
            return this.canNotSelectedIds.indexOf(item.id) >= 0
        }
    }
}
// 判断当前节点是否全部被选中，若选中，则上级节点选中，逐层往上递归
function checkOrgSelect(item, context) {
    if (!item.idPath) {
        return
    }
    const orgIds = item.idPath.split(',')
    checkOrgs(orgIds, 0, context)
}
function checkOrgs(orgIds, index, context) {
    const orgIndex = orgIds.length - index - 1
    if (orgIndex < 0) {
        return
    }
    const bizId = orgIds[orgIndex]
    let deptList = []
    let memberList = []
    const func = function() {
        memberList = memberList.filter(item => !context.isDisabled(item))
        for (let i = 0, memberLen = memberList.length; i < memberLen; i += 1) {
            const member = memberList[i]
            const memberId = member.uId
            if (context.selectedIdList.indexOf(memberId) === -1) {
                return
            }
        }
        for (let i = 0, deptLen = deptList.length; i < deptLen; i += 1) {
            const dept = deptList[i]
            if (context.selectedOrgs.indexOf(dept.bizId) === -1) {
                return
            }
        }
        // 如果当前组织节点已经被选中，说明在联动的其他节点递归时已经被选中了，不用继续递归了，提升性能
        if (context.selectedOrgs.indexOf(bizId) > -1) {
            return
        }
        // 已选中添加当前组织节点，继续递归
        context.selectedOrgs.push(bizId)
        checkOrgs(orgIds, index + 1, context)
    }
    if (context.crumbCacheList[bizId]) {
        memberList = context.crumbCacheList[bizId].members
        deptList = context.crumbCacheList[bizId].depts
        func()
    } else {
        getNextOrganization(bizId, (err, res) => {
            const depts = []
            const members = []
            if (err) {
                // context.$message({
                //     message: '获取数据失败',
                //     type: 'error',
                //     duration: 3000
                // })
                return
            }
            res.forEach(item => {
                if (item.type === contactsConfig.DEPT) {
                    depts.push(item)
                } else if (item.type === contactsConfig.STAFF) {
                    members.push(item)
                }
            })
            memberList = members
            deptList = depts
            func()
        })
    }
}
/**
 * 添加人员
 * 排除已选中
 * @param {Array<staff>} members
 * @param {Object} context
 */

function addMembers(members, context) {
    members = members.filter(item => !context.isDisabled(item))
    // 先给 members 去重
    members = uniq(members)
    members = without(members, context.selected)
    if (members.length > 0) {
        context.$emit('added', members)
    }
}

function uniq(array) {
    const map = {}
    return array.filter(item => {
        const id = item.id
        if (map[id]) {
            return false
        }
        map[id] = id
        return true
    })
}

function without(members, others) {
    const otherIds = others.map(item => item.id)
    return members.filter(item => otherIds.indexOf(item.id) < 0)
}
</script>

<style lang="scss" scoped>
.myDept-box {
    height: 100%;
    overflow-y: auto;
    .org-status {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding-bottom: 94px;
        box-sizing: border-box;
        .status-img {
            width: 90px;
            height: 90px;
        }
        .status-text {
            margin-top: 12px;
            font-size: 14px;
            line-height: 22px;
            color: #464646;
        }
        .status-reload {
            width: 180px;
            height: 36px;
            margin-top: 18px;
            .reload {
                width: 100%;
                height: 36px;
                font-size: 14px;
                color: #fff;
                text-align: center;
                line-height: 36px;
                border: 0;
                background: #007af5;
                border-radius: 2px;
                cursor: pointer;
                &:hover {
                    background-color: #006edd;
                }
            }
        }
    }
    .deptMain {
        .deptBread {
            margin-top: 12px;
            padding: 0 12px;
            box-sizing: border-box;
            display: flex;
            align-items: flex-start;
            &:first-child {
                margin-top: 0;
            }
            .arrow {
                cursor: pointer;
                //margin-right: 3px;
                width: 24px;
                height: 24px;
                display: block;
                flex-shrink: 0;
                &.rotate {
                    transform: rotate(90deg);
                    // color: #5587F0;
                }
            }
            .breadDetail {
                a {
                    font-size: 14px;
                    line-height: 24px;
                    color: #007af5;
                    cursor: pointer;
                }
                span {
                    font-size: 14px;
                    line-height: 24px;
                    color: #6f6f6f;
                }
                i {
                    font-size: 12px;
                    line-height: 18px;
                    color: #d6d6d6;
                    margin: 0 6px;
                }
            }
        }
        .deptDetail {
            .checkIcon {
                cursor: pointer;
                display: flex;
                align-items: center;
                input {
                    display: none;
                    & + i {
                        width: 24px;
                        height: 24px;
                        display: block;
                        background: url('../../../assets/images/contacts/org-window-choose-default.png');
                        background-size: 100% 100%;
                        //&:hover {
                        //    background: url('../../../assets/images/contacts/org-window-choose-hover.png');
                        //    background-size: 100% 100%;
                        //}
                    }
                    &:checked + i {
                        width: 24px;
                        height: 24px;
                        display: block;
                        background: url('../../../assets/images/contacts/org-window-choose-ok.png');
                        background-size: 100% 100%;
                    }
                    &:checked[disabled] + i {
                        width: 24px;
                        height: 24px;
                        display: block;
                        background: url('../../../assets/images/contacts/org-window-choose-no.png');
                        background-size: 100% 100%;
                    }
                    &[disabled] + i {
                        width: 24px;
                        height: 24px;
                        display: block;
                        background: url('../../../assets/images/contacts/org-window-choose-disableno.png');
                        background-size: 100% 100%;
                    }
                }
            }
            .allCheck {
                height: 36px;
                display: flex;
                align-items: center;
                box-sizing: border-box;
                margin: 0 6px;
                padding: 0 6px;
                cursor: pointer;
                border-radius: 4px;
                &:hover {
                    background-color: #f5f5f5;
                }
                span {
                    font-size: 14px;
                    line-height: 24px;
                    color: #323232;
                    margin-left: 12px;
                }
            }
            .memberList {
                .member {
                    display: flex;
                    align-items: center;
                    height: 54px;
                    border-radius: 4px;
                    margin: 0 6px;
                    padding: 0 6px;
                    cursor: pointer;
                    &:hover {
                        background-color: #f5f5f5;
                    }
                    .avatar {
                        width: 36px;
                        height: 36px;
                        margin: 0 12px;
                    }
                    .detail {
                        flex: 1;
                        overflow: hidden;
                        .name {
                            font-size: 14px;
                            line-height: 22px;
                            color: #323232;
                            overflow: hidden;
                            display: flex;
                            .name-flex {
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                                max-width: 115px;
                                padding-right: 6px;
                            }
                            .account {
                                flex: 1;
                                white-space: nowrap;
                                text-overflow: ellipsis;
                                overflow: hidden;
                            }
                        }
                        .position {
                            font-size: 12px;
                            line-height: 18px;
                            color: #999999;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                        }
                    }
                }
            }
            .deptList {
                .dept {
                    display: flex;
                    align-items: center;
                    height: 36px;
                    margin: 0 6px;
                    padding: 0 6px;
                    border-radius: 4px;
                    cursor: pointer;
                    &:hover {
                        background-color: #f5f5f5;
                    }
                    .detail {
                        font-size: 14px;
                        line-height: 22px;
                        color: #323232;
                        flex: 1;
                        text-indent: 12px;
                    }
                    .expandIcon {
                        width: 18px;
                        height: 18px;
                    }
                }
            }
            .org-default-bg {
                height: 68px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #999;
                font-size: 12px;
            }
            &.hasArrow {
                .allCheck,
                .member,
                .dept {
                    padding-left: 30px;
                }
            }
        }
    }
}
</style>
